import { useQuery } from '@tanstack/react-query';
import { get } from '@core/api/baseApi';
import { GetDefaultTemplateResponse } from '@core/types';

export const getFolders = (): Promise<GetDefaultTemplateResponse> =>
  get('/ReportTemplates/default');

export const GET_DEFAULT_TEMPLATE_QUERY_KEY = 'defaulttemplate';

const useGetDefaultTemplate = () => {
  const { data: defaultTemplate, ...rest } = useQuery({
    queryKey: [GET_DEFAULT_TEMPLATE_QUERY_KEY],
    queryFn: () => getFolders(),
    retry: false,
  });

  return {
    defaultTemplate,
    ...rest,
  };
};

export default useGetDefaultTemplate;
